import { DisplayGroupValue } from 'src/models/formsHandler/formsHandler';

export function resolveValueFunctionFormula(displayGroupValue: DisplayGroupValue): string {
  let formula = displayGroupValue.value.formula
  for (var i = 0; i < displayGroupValue.value.params.length; i++) {
    const param = displayGroupValue.value.params[i]
    formula = formula.replaceAll('{' + i + '}', param.optional ? `{${param.attributeName}` : `[${param.attributeName}]`);
  }
  return formula;
}